import { type SyntheticEvent } from 'react';
import { Box, Typography } from '@mui/material';
import { Linkable } from '@/components/blocks/Linkable';
import { Img } from '@/components/blocks/MaterialImage';
import { useLocalization } from '@/data/Localization';
import { ACCOUNT_QUERY_TABS } from '@/components/content/Account';
import { useUserCheckLoggedIn } from '@/data/User';
import { combineSX } from '@/utils/combineSX';
import { headerMobileLinkBaseSX } from '@/components/content/Header/styles/mobileDrawer';

interface Props {
	onLinkClick?: (event: SyntheticEvent) => void;
}

export const MyOrdersLink = ({ onLinkClick }: Props) => {
	const RouteLocal = useLocalization('Routes');
	const { isLoggedIn } = useUserCheckLoggedIn();

	if (!isLoggedIn) {
		return null;
	}

	return (
		<Linkable
			href={{
				pathname: `/${RouteLocal.Account.route.t()}`,
				query: { tab: ACCOUNT_QUERY_TABS.ORDERS_HISTORY },
			}}
			sx={combineSX([
				headerMobileLinkBaseSX,
				{
					padding: '8px 0px',
					mt: '8px',
				},
			])}
			onClick={onLinkClick}
		>
			<Img src="/images/box.svg" alt="Mis pedidos" sx={{ width: '18px' }} />
			<Box>
				Mis pedidos
				<Typography
					sx={{
						color: '#707070',
						fontSize: '13px',
					}}
				>
					Rastrea tus compras aquí
				</Typography>
			</Box>
		</Linkable>
	);
};
